export const typeDefs = `

`


export const defaults = {

}




export const resolvers = {
  
}


// WEBPACK FOOTER //
// ./src/resolvers/index.js